export const gid_status_enum = [
  "IDEA",
  "IN_PROGRESS",
  "WAITING_FOR_DEVELOPMENT",
  "DEAD",
  "DONE",
];
